import { Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Radio, RadioGroup, Typography } from '@material-ui/core';
import cx from 'classnames';
import * as React from 'react';
import { translate } from '../../../../../common/intl';
import { statusClassMapping } from '../../../../components/common/kendo/helpers';
import { DialogHandler } from '../../../../hooks/useDialog';
import { EditableAllocationItem } from '../../interface';
import { styles } from '../treelist/column.templates/styles';
import { AlternatePartDetails } from '../treelist/interface';

interface ReplacementDialogProps {
  dataItem: EditableAllocationItem
  onConfirmReplacement?: (selectedAlternatePart: AlternatePartDetails) => void
  replacementDialog: DialogHandler
  availableAlternateParts: AlternatePartDetails[]
}

const PartReplacementDialog: React.FunctionComponent<ReplacementDialogProps>
  = ({
    dataItem,
    onConfirmReplacement,
    replacementDialog,
    availableAlternateParts = [],
  }) => {
    const classes = styles();
    const [selectedAlternatePartId, setSelectedAlternatePartId] = React.useState<string>('');

    const selectedAlternatePart = availableAlternateParts.find(
      part => part.id === selectedAlternatePartId,
    );

    return (
      <Dialog
        disableEscapeKeyDown
        disableBackdropClick
        open={replacementDialog.isOpen}
        maxWidth="md"
        classes={{
          paper: classes.replacementDialogPaper,
        }}
      >
        <DialogTitle>{translate('allocation.select.alternate.part.dialog.title',
          { name: dataItem.docId, version: dataItem.displayRevision })}</DialogTitle>
        <DialogContent dividers>
          <RadioGroup
            value={selectedAlternatePartId}
            onChange={(e) => setSelectedAlternatePartId(e.target.value)}
          >
            {availableAlternateParts.map((part) => (
              <Box className={classes.alternatePartBox}
                key={part.id}
              >
                <FormControlLabel
                  value={part.id}
                  control={<Radio />}
                  label={
                    <Box className={classes.labelBox}>
                      <Box className={classes.labelText}>
                        <Typography variant="h5" >
                          {part.docId} • Rev {part.displayRevision}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          {part.name}
                        </Typography>
                      </Box>
                      <Chip
                        size="small"
                        className={cx(
                          classes.chip,
                          classes[statusClassMapping[part.displayStatus]],
                        )}
                        label={part.displayStatus}
                      />
                    </Box>
                  }
                />
              </Box>
            ))}
          </RadioGroup>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={replacementDialog.close}
            variant="text"
          >
            {translate('common.cancel')}
          </Button>

          <Button
            color="primary"
            variant="contained"
            disabled={!selectedAlternatePart}
            onClick={() => selectedAlternatePart && onConfirmReplacement?.(selectedAlternatePart)}
          >
            {translate('common.update')}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

export default PartReplacementDialog;
